module.exports = __webpack_public_path__ + "media/scholarship_winners/joanne-sw-295ebe19.png";